var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { Alert } from "@mui/material";
import React, { useState, useEffect, useContext, useCallback, useRef } from "react";
import { useTranslation } from "react-i18next";
import { ConfirmationLayout, Dialog, ConfirmationActions, StyledButton, VisuallyHidden, } from "@sequentech/ui-essentials";
import { stringToHtml, EElectionEventContestEncryptionPolicy, areAllContestsAcclaimed, EVotingPortalAuditButtonCfg, } from "@sequentech/ui-core";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../store/hooks";
import { selectAuditableBallot, selectIsBlankBallot, } from "../store/auditableBallots/auditableBallotsSlice";
import { canVoteElection } from "../store/castVotes/castVotesSlice";
import { useVoterContext } from "../hooks/useVoterContext";
import { isElectionOpenForVoting } from "../services/VotingAvailability";
import { selectElectionEventById } from "../store/electionEvents/electionEventsSlice";
import { clearBallot } from "../store/ballotSelections/ballotSelectionsSlice";
import { selectBallotStyleByElectionId, selectFirstBallotStyle, } from "../store/ballotStyles/ballotStylesSlice";
import { AuthContext } from "../providers/AuthContextProvider";
import { useMutation } from "@apollo/client/react";
import { CREATE_BALLOT_RECEIPT } from "../queries/CreateBallotReceipt";
import { useReceiptDocument } from "../hooks/useReceiptDocument";
import Stepper from "../components/Stepper";
import { SettingsContext } from "../providers/SettingsContextProvider";
import { provideBallotService } from "../services/BallotService";
import { VotingPortalError, VotingPortalErrorType } from "../services/VotingPortalError";
import { downloadUrl } from "@sequentech/ui-core";
import { selectConfirmationScreenData, } from "../store/castVotes/confirmationScreenDataSlice";
import { selectReceivedBallot } from "../store/receivedBallots/receivedBallotsSlice";
var ActionButtons = function (_a) {
    var _b, _c, _d;
    var ballotTrackerUrl = _a.ballotTrackerUrl, electionId = _a.electionId, ballotId = _a.ballotId, isFullyAcclaimed = _a.isFullyAcclaimed;
    var _e = useContext(AuthContext), isKiosk = _e.isKiosk, logout = _e.logout;
    var t = useTranslation().t;
    var _f = useParams(), tenantId = _f.tenantId, eventId = _f.eventId;
    var storedCastVotes = useAppSelector(function (state) { return state.castVotes; });
    var completedAcclaimedElections = useAppSelector(function (state) { return state.extra.completedAcclaimedElections; });
    var navigate = useNavigate();
    var location = useLocation();
    var ballotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    var dispatch = useAppDispatch();
    var electionEvent = useAppSelector(selectElectionEventById(eventId));
    var createBallotReceipt = useMutation(CREATE_BALLOT_RECEIPT)[0];
    var _g = useState(null), documentId = _g[0], setDocumentId = _g[1];
    var globalSettings = useContext(SettingsContext).globalSettings;
    var _h = useState(false), errorDialog = _h[0], setErrorDialog = _h[1];
    var _j = useState(false), openPrintDemoModal = _j[0], setOpenPrintDemoModal = _j[1];
    var oneBallotStyle = useAppSelector(selectFirstBallotStyle);
    var isDemo = (_b = oneBallotStyle === null || oneBallotStyle === void 0 ? void 0 : oneBallotStyle.ballot_eml.public_key) === null || _b === void 0 ? void 0 : _b.is_demo;
    var _k = useState(false), isPolling = _k[0], setIsPolling = _k[1];
    var presentation = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation;
    // Eligibility includes elections whose ballots have never been downloaded,
    // including after a direct entry or golden-policy reauthentication.
    var voterContext = useVoterContext();
    var _l = useReceiptDocument(eventId, documentId), ballotReceiptDocuments = _l.data, receiptError = _l.error, startPolling = _l.startPolling, stopPolling = _l.stopPolling;
    var canVote = (_c = voterContext.data) === null || _c === void 0 ? void 0 : _c.sequent_backend_election.some(function (election) {
        var _a, _b, _c, _d, _e, _f;
        // Bootstrap includes earlier votes, while Redux also has the cast that
        // just completed. Merge by ID so cached metadata neither loses nor
        // double-counts that vote after normal or golden authentication.
        var votes = new Map();
        for (var _i = 0, _g = (_b = (_a = voterContext.data) === null || _a === void 0 ? void 0 : _a.cast_votes) !== null && _b !== void 0 ? _b : []; _i < _g.length; _i++) {
            var vote = _g[_i];
            if (vote.election_id === election.id)
                votes.set(vote.id, vote);
        }
        for (var _h = 0, _j = storedCastVotes[election.id] || []; _h < _j.length; _h++) {
            var vote = _j[_h];
            votes.set(vote.id, vote);
        }
        return (canVoteElection(election, Array.from(votes.values()), completedAcclaimedElections === null || completedAcclaimedElections === void 0 ? void 0 : completedAcclaimedElections[election.id]) &&
            isElectionOpenForVoting({
                electionStatus: election.status,
                eventStatus: (_d = (_c = voterContext.data) === null || _c === void 0 ? void 0 : _c.sequent_backend_election_event[0]) === null || _d === void 0 ? void 0 : _d.status,
                channels: election.voting_channels,
                areaPresentation: (_f = (_e = voterContext.summaries) === null || _e === void 0 ? void 0 : _e[election.id]) === null || _f === void 0 ? void 0 : _f.area_presentation,
                isKiosk: isKiosk(),
            }));
    });
    var waitingForEligibility = !globalSettings.DISABLE_AUTH && (voterContext.loading || !voterContext.data);
    var onClickFinishButton = useCallback(function () {
        if (waitingForEligibility)
            return;
        if (canVote || globalSettings.DISABLE_AUTH) {
            navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser").concat(location.search));
        }
        else {
            var redirectUrl = isKiosk()
                ? presentation === null || presentation === void 0 ? void 0 : presentation.kiosk_redirect_finish_url
                : presentation === null || presentation === void 0 ? void 0 : presentation.redirect_finish_url;
            logout(redirectUrl);
        }
    }, [
        waitingForEligibility,
        canVote,
        globalSettings.DISABLE_AUTH,
        navigate,
        tenantId,
        eventId,
        location.search,
        isKiosk,
        presentation,
        logout,
    ]);
    useEffect(function () {
        if (ballotStyle) {
            dispatch(clearBallot());
        }
    }, [ballotStyle, dispatch]);
    var _m = useState(false), isDownloadingReport = _m[0], setIsDownloadingReport = _m[1];
    var _o = useState(false), isHitPrint = _o[0], setIsHitPrint = _o[1];
    var maxRetries = 5;
    var retryInterval = globalSettings.QUERY_POLL_INTERVAL_MS;
    function printBallotReceiptReport() {
        return __awaiter(this, void 0, void 0, function () {
            var res, docId, _a;
            var _b, _c;
            return __generator(this, function (_d) {
                switch (_d.label) {
                    case 0:
                        setIsHitPrint(true);
                        if (isDemo) {
                            setOpenPrintDemoModal(true);
                            return [2 /*return*/];
                        }
                        _d.label = 1;
                    case 1:
                        _d.trys.push([1, 4, , 5]);
                        setErrorDialog(false);
                        if (!!documentId) return [3 /*break*/, 3];
                        if (!ballotTrackerUrl) {
                            setIsHitPrint(false);
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, createBallotReceipt({
                                variables: {
                                    ballot_id: ballotId,
                                    ballot_tracker_url: ballotTrackerUrl,
                                    election_event_id: eventId,
                                    tenant_id: tenantId,
                                    election_id: electionId,
                                },
                            })];
                    case 2:
                        res = _d.sent();
                        docId = (_c = (_b = res.data) === null || _b === void 0 ? void 0 : _b.create_ballot_receipt) === null || _c === void 0 ? void 0 : _c.id;
                        if (!docId)
                            throw new Error("Receipt generation returned no document");
                        setDocumentId(docId);
                        _d.label = 3;
                    case 3:
                        setIsDownloadingReport(true);
                        return [3 /*break*/, 5];
                    case 4:
                        _a = _d.sent();
                        failReceipt();
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    var failReceipt = useCallback(function () {
        stopPolling();
        setDocumentId(null);
        setIsPolling(false);
        setIsDownloadingReport(false);
        setIsHitPrint(false);
        setErrorDialog(true);
    }, [stopPolling]);
    useEffect(function () {
        if (documentId && receiptError)
            failReceipt();
    }, [documentId, receiptError, failReceipt]);
    useEffect(function () {
        if (!documentId)
            return;
        var timeout = setTimeout(failReceipt, globalSettings.POLLING_DURATION_TIMEOUT);
        return function () { return clearTimeout(timeout); };
    }, [documentId, globalSettings.POLLING_DURATION_TIMEOUT, failReceipt]);
    function downloadFileWithRetry(url_1, name_1) {
        return __awaiter(this, arguments, void 0, function (url, name, retries) {
            var error_1;
            if (retries === void 0) { retries = 0; }
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, downloadUrl(url, name)];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error downloading file:", error_1);
                        if (retries < maxRetries) {
                            setTimeout(function () {
                                downloadFileWithRetry(url, name, retries + 1);
                            }, retryInterval);
                        }
                        else {
                            console.error("Failed to download file after", maxRetries, "retries");
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    }
    useEffect(function () {
        var _a;
        if (documentId &&
            !receiptError &&
            ((_a = ballotReceiptDocuments === null || ballotReceiptDocuments === void 0 ? void 0 : ballotReceiptDocuments.receipt_document.payload.document) === null || _a === void 0 ? void 0 : _a.id) === documentId) {
            var fileName = "ballot_receipt_".concat(eventId, ".pdf");
            var documentUrl = ballotReceiptDocuments.receipt_document.payload.document.url;
            downloadFileWithRetry(documentUrl, fileName);
            setIsDownloadingReport(false);
            setIsHitPrint(false);
            setIsPolling(false);
            setDocumentId(null);
            stopPolling();
        }
    }, [(_d = ballotReceiptDocuments === null || ballotReceiptDocuments === void 0 ? void 0 : ballotReceiptDocuments.receipt_document.payload.document) === null || _d === void 0 ? void 0 : _d.id, documentId, receiptError]);
    useEffect(function () {
        if (!isPolling && documentId && !receiptError) {
            setIsPolling(true);
            startPolling(globalSettings.QUERY_POLL_INTERVAL_MS);
        }
    }, [startPolling, globalSettings.QUERY_POLL_INTERVAL_MS, documentId, isPolling, receiptError]);
    return (_jsxs(_Fragment, { children: [voterContext.error && !globalSettings.DISABLE_AUTH ? (_jsx(Alert, { severity: "error", className: "remaining-elections-error", action: _jsx(StyledButton, { className: "remaining-elections-retry-button", variant: "secondary", onClick: function () { return void voterContext.retry(); }, disabled: voterContext.loading, children: t("confirmationScreen.retryButton") }), children: t("confirmationScreen.remainingElectionsError") })) : null, _jsx(VisuallyHidden, { className: "remaining-elections-status", role: "status", children: waitingForEligibility && !voterContext.error ? t("a11y.loading") : "" }), _jsx(ConfirmationActions, { withPrint: !isFullyAcclaimed, printing: isHitPrint, onPrint: isDemo || documentId || ballotTrackerUrl ? printBallotReceiptReport : undefined, onFinish: waitingForEligibility || voterContext.error ? undefined : onClickFinishButton }), _jsx(Dialog, { className: "demo-print-receipt-dialog", handleClose: function () { return setOpenPrintDemoModal(false); }, open: openPrintDemoModal, title: t("confirmationScreen.demoPrintDialog.title"), ok: t("confirmationScreen.demoPrintDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.demoPrintDialog.content")) }), _jsx(Dialog, { className: "print-receipt-error-dialog", handleClose: function () { return setErrorDialog(false); }, open: errorDialog, title: t("confirmationScreen.errorDialogPrintBallotReceipt.title"), ok: t("confirmationScreen.errorDialogPrintBallotReceipt.ok"), variant: "warning", children: stringToHtml(t("confirmationScreen.errorDialogPrintBallotReceipt.content")) })] }));
};
var ConfirmationScreen = function () {
    var _a, _b, _c, _d, _e, _f;
    var isKiosk = useContext(AuthContext).isKiosk;
    var _g = useParams(), tenantId = _g.tenantId, eventId = _g.eventId;
    var electionId = useParams().electionId;
    var auditableBallot = useAppSelector(selectAuditableBallot(String(electionId)));
    var isBlankBallot = useAppSelector(selectIsBlankBallot(String(electionId)));
    var confirmationScreenData = useAppSelector(selectConfirmationScreenData(String(electionId)));
    var receivedBallot = useAppSelector(selectReceivedBallot(String(electionId)));
    var t = useTranslation().t;
    var _h = useState(false), openBallotIdHelp = _h[0], setOpenBallotIdHelp = _h[1];
    var _j = useState(false), openConfirmationHelp = _j[0], setOpenConfirmationHelp = _j[1];
    var _k = useState(false), openDemoBallotUrlHelp = _k[0], setDemoBallotUrlHelp = _k[1];
    var _l = provideBallotService(), hashBallot = _l.hashBallot, hashMultiBallot = _l.hashMultiBallot;
    var oneBallotStyle = useAppSelector(selectFirstBallotStyle);
    var electionBallotStyle = useAppSelector(selectBallotStyleByElectionId(String(electionId)));
    var auditButtonCfg = (_d = (_c = (_b = (_a = electionBallotStyle === null || electionBallotStyle === void 0 ? void 0 : electionBallotStyle.ballot_eml) === null || _a === void 0 ? void 0 : _a.election_presentation) === null || _b === void 0 ? void 0 : _b.audit_button_cfg) !== null && _c !== void 0 ? _c : confirmationScreenData === null || confirmationScreenData === void 0 ? void 0 : confirmationScreenData.auditButtonCfg) !== null && _d !== void 0 ? _d : EVotingPortalAuditButtonCfg.SHOW;
    // Nothing was cast for a fully acclaimed election, so this screen confirms
    // what was decided rather than a ballot, and shows no ballot id anywhere.
    var isFullyAcclaimed = areAllContestsAcclaimed(electionBallotStyle === null || electionBallotStyle === void 0 ? void 0 : electionBallotStyle.ballot_eml.contests);
    var getBallotId = function () {
        var _a, _b;
        if (!auditableBallot) {
            if (!confirmationScreenData) {
                console.log("confirmationScreenData not found in redux");
                return {
                    ballotIdStored: undefined,
                    ballotHashStored: undefined,
                    isDemoStored: undefined,
                };
            }
            else {
                return {
                    ballotIdStored: confirmationScreenData.ballotId,
                    ballotHashStored: undefined,
                    isDemoStored: confirmationScreenData.isDemo,
                };
            }
        }
        else {
            console.log("auditableBallot normal flow");
            var isMultiContest = ((_a = auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.config.election_event_presentation) === null || _a === void 0 ? void 0 : _a.contest_encryption_policy) ==
                EElectionEventContestEncryptionPolicy.MULTIPLE_CONTESTS;
            var hashableBallot = isMultiContest
                ? hashMultiBallot(auditableBallot)
                : hashBallot(auditableBallot);
            var ballotHashStored = (auditableBallot && hashableBallot) || undefined;
            // A ballot the ballot box received at review is known by the
            // Ballot ID the ballot box signed for it.
            var ballotIdStored = receivedBallot && receivedBallot.ballot_hash === ballotHashStored
                ? receivedBallot.ballot_id
                : ballotHashStored;
            var isDemoStored = (_b = oneBallotStyle === null || oneBallotStyle === void 0 ? void 0 : oneBallotStyle.ballot_eml.public_key) === null || _b === void 0 ? void 0 : _b.is_demo;
            return { ballotIdStored: ballotIdStored, ballotHashStored: ballotHashStored, isDemoStored: isDemoStored };
        }
    };
    var ballotId = useRef(undefined);
    var ballotHash = useRef(undefined);
    var gotData = useRef(false);
    var navigate = useNavigate();
    var _m = useState(false), demoBallotIdHelp = _m[0], setDemoBallotIdHelp = _m[1];
    var _o = useState(false), isDemo = _o[0], setIsDemo = _o[1];
    var _p = useState(undefined), ballotTrackerUrl = _p[0], setBallotTrackerUrl = _p[1];
    if (gotData.current &&
        (auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash) &&
        ballotHash.current !== (auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash)) {
        console.log("ballotId: ".concat(ballotHash.current, "\n auditable Ballot Hash: ").concat(auditableBallot === null || auditableBallot === void 0 ? void 0 : auditableBallot.ballot_hash));
        throw new VotingPortalError(VotingPortalErrorType.INCONSISTENT_HASH);
    }
    useEffect(function () {
        if (isFullyAcclaimed) {
            return;
        }
        if (!gotData.current) {
            gotData.current = true;
            var _a = getBallotId(), ballotIdStored = _a.ballotIdStored, ballotHashStored = _a.ballotHashStored, isDemoStored = _a.isDemoStored;
            if (!ballotIdStored) {
                console.log("No stored ballot found, navigating to the election-chooser page.");
                navigate("/tenant/".concat(tenantId, "/event/").concat(eventId, "/election-chooser"));
            }
            ballotId.current = ballotIdStored;
            ballotHash.current = ballotHashStored;
            setIsDemo(isDemoStored !== null && isDemoStored !== void 0 ? isDemoStored : false);
            setBallotTrackerUrl("".concat(window.location.protocol, "//").concat(window.location.host, "/tenant/").concat(tenantId, "/event/").concat(eventId, "/election/").concat(electionId, "/ballot-locator/").concat(ballotIdStored).concat(isKiosk() ? "?kiosk" : ""));
        }
    }, []);
    var handleBallotIdLinkClick = function (event) {
        if (isDemo) {
            event.preventDefault();
            setDemoBallotUrlHelp(true);
        }
        else if (isKiosk() && ballotTrackerUrl) {
            // Keep the in-memory kiosk session; a new tab starts a fresh login.
            event.preventDefault();
            var _a = new URL(ballotTrackerUrl), pathname = _a.pathname, search = _a.search;
            navigate({ pathname: pathname, search: search });
        }
    };
    return (
    // The arrangement is `ConfirmationLayout`, in `ui-essentials`, so the
    // Election Architect's preview shows this screen rather than a copy of
    // it. What stays here is what needs the store, the router or this
    // screen's own state: the breadcrumb, the dialogs, and the actions.
    _jsxs(ConfirmationLayout, { steps: _jsx(Stepper, { selected: 3 }), onTitleHelp: function () { return setOpenConfirmationHelp(true); }, isFullyAcclaimed: isFullyAcclaimed, isBlankBallot: isBlankBallot, ballotId: (_e = ballotId.current) !== null && _e !== void 0 ? _e : "", ballotIdOnPhone: t("ballotHash", { ballotId: ballotId.current }), ballotIdHref: isDemo ? undefined : ballotTrackerUrl, ballotIdTarget: isKiosk() ? null : "_blank", onBallotIdClick: handleBallotIdLinkClick, onBallotIdHelp: function () { return (isDemo ? setDemoBallotIdHelp(true) : setOpenBallotIdHelp(true)); }, ballotIdCopyLabels: auditButtonCfg !== EVotingPortalAuditButtonCfg.NOT_SHOW
            ? {
                copy: t("reviewScreen.copyBallotId"),
                copied: t("reviewScreen.ballotIdCopied"),
                error: t("reviewScreen.ballotIdCopyError"),
            }
            : undefined, qrValue: isDemo ? t("confirmationScreen.demoQRText") : (ballotTrackerUrl !== null && ballotTrackerUrl !== void 0 ? ballotTrackerUrl : ""), actions: _jsx(ActionButtons, { ballotTrackerUrl: ballotTrackerUrl, electionId: electionId, ballotId: (_f = ballotId.current) !== null && _f !== void 0 ? _f : "", isFullyAcclaimed: isFullyAcclaimed }), children: [_jsx(Dialog, { className: "screen-help-dialog confirmation-help-dialog", handleClose: function () { return setOpenConfirmationHelp(false); }, open: openConfirmationHelp, title: t(isFullyAcclaimed
                    ? "confirmationScreen.acclamation.helpDialog.title"
                    : "confirmationScreen.confirmationHelpDialog.title"), ok: t(isFullyAcclaimed
                    ? "confirmationScreen.acclamation.helpDialog.ok"
                    : "confirmationScreen.confirmationHelpDialog.ok"), variant: "info", children: stringToHtml(t(isFullyAcclaimed
                    ? "confirmationScreen.acclamation.helpDialog.content"
                    : "confirmationScreen.confirmationHelpDialog.content")) }), _jsx(Dialog, { className: "ballot-id-help-dialog", handleClose: function () { return setOpenBallotIdHelp(false); }, open: openBallotIdHelp, title: t("confirmationScreen.ballotIdHelpDialog.title"), ok: t("confirmationScreen.ballotIdHelpDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.ballotIdHelpDialog.content")) }), _jsx(Dialog, { className: "demo-ballot-url-dialog", handleClose: function () { return setDemoBallotUrlHelp(false); }, open: openDemoBallotUrlHelp, title: t("confirmationScreen.demoBallotUrlDialog.title"), ok: t("confirmationScreen.demoBallotUrlDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.demoBallotUrlDialog.content")) }), _jsx(Dialog, { className: "demo-ballot-id-help-dialog", handleClose: function () { return setDemoBallotIdHelp(false); }, open: demoBallotIdHelp, title: t("confirmationScreen.ballotIdDemoHelpDialog.title"), ok: t("confirmationScreen.ballotIdDemoHelpDialog.ok"), variant: "info", children: stringToHtml(t("confirmationScreen.ballotIdDemoHelpDialog.content")) })] }));
};
export default ConfirmationScreen;
